import { BaseDto } from './base.dto';
import { CartDto } from './cart.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
import { SaleUnitCartSplitDto } from './saleUnitCartSplit.dto';
import { OrderDto } from './order.dto';

export class CartOrderDto extends BaseDto {
  guid: string | null;
  cartId: number;
  saleUnitCartId: number;
  saleUnitCartSplitId: number | null;
  guestId: number | null;
  orderId: number;
  isPartialPayment?: boolean;
  isPartialCardPayment?: boolean;
  /**
   * Relations
   */
  cart?: CartDto;
  saleUnitCart?: SaleUnitCartDto;
  saleUnitCartSplit?: SaleUnitCartSplitDto;
  order?: OrderDto;
}
